import type { PriceSource } from './api';

const PRICE_SOURCE_LABELS: Record<PriceSource, string> = {
  CONTRACT_MENU: 'Contrato (menú)',
  CONTRACT_SERVICE_TYPE: 'Contrato (servicio)',
  CATALOG: 'Catálogo',
};

/** Where an order line's frozen price came from; `null` = line created before the origin was recorded. */
export function priceSourceLabel(source: PriceSource | null): string {
  return source === null ? '—' : PRICE_SOURCE_LABELS[source];
}
